import generics from "./generics";

export default [
    ...generics
] 